import React from 'react';

import { Switch, FormControlLabel } from '@material-ui/core';
import useCars from '../../../../context/useCars';
import { useTranslations } from 'components/utilities';

const DropCitySwitch = () => {
	const { t } = useTranslations();
	const { dropInDifferentCity, handleDropInDifferentCityChange } = useCars();

	return (
		<FormControlLabel
			control={
				<Switch
					checked={dropInDifferentCity}
					onChange={handleDropInDifferentCityChange}
					color="primary"
				/>
			}
			label={t('cars.dropOffCityLabel')}
		/>
	);
};

export default DropCitySwitch;
